/* eslint-disable no-useless-escape */
import { useState, useEffect } from "react";
import NRIC from 'singapore-nric';

interface Iprops {
  firstPassword?: string;
  secondPassword?: string;
  length?: number;
  callback?: Function;
  text?: any;
  textType?: any;
  paramPattern?: string;
  patternType?: string;
  login?: boolean
}


let emailPattern = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
let mobilePattern= "^(?:\\+65)?[89][0-9]{7}$";

let floorPattern = "^[a-zA-Z0-9]{1,3}$";
let unitPattern = "^[a-zA-Z0-9]{1,6}$";
let nricPattern = "^[STFG]\\d{7}[A-Z]$"
let uenPattern = /^(?:\\d{9}[A-Z]|[ST]\\d{2}[A-Z]{2}\\d{4}[A-Z])$/;

export const PasswordValidators = (props: Iprops) => {
  const [validLength, setValidLength] = useState(true);
  const [hasNumber, setHasNumber] = useState(true);
  const [upperCase, setUpperCase] = useState(true);
  const [lowerCase, setLowerCase] = useState(true);
  const [specialChar, setSpecialChar] = useState(true);
  const [match, setMatch] = useState(true);
  const [required, setRequired] = useState(false);

  useEffect(() => {
    if (props.firstPassword) {
      if (props.length) {
        setValidLength(
          props.firstPassword.length >= props.length ? true : false
        );
      } else setValidLength(true);
      setUpperCase(
        props.firstPassword.toLowerCase() !== props.firstPassword
      );
      setLowerCase(props.firstPassword.toUpperCase() !== props.firstPassword);
      setHasNumber(/\d/.test(props.firstPassword));
      setSpecialChar(
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>?~]/.test(props.firstPassword)
      );
      setRequired(props.firstPassword.length > 0 ? true : false);

      if (props.secondPassword) {
        setMatch(
          !!props.firstPassword && props.firstPassword === props.secondPassword
        );
      } else setMatch(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  return (
    <div className="mb-16">
      {!required && <div className="text-danger">Password is required.</div>}
      {
        required &&
        <>
        
      {!validLength && !props.login && (
        <div className="text-danger">Password is at least 8 characters.</div>
      )}
      {!hasNumber && !props.login && (
        <div className="text-danger">Password must be included number.</div>
      )}
      {!upperCase && !props.login && (
        <div className="text-danger">
          Password must be included capital letter.
        </div>
      )}
      {!lowerCase && !props.login && (
        <div className="text-danger">
          Password must be included small letter.
        </div>
      )}
      {!specialChar && !props.login && (
        <div className="text-danger">
          Password must be included special character.
        </div>
      )}
      {props.secondPassword && !match && !props.login && (
        <div className="text-danger">
          Password and Confirm Password must be the same.
        </div>
      )}
        </>
      }
    </div>
  );
};

export function validPassword(props : any): any {
  if(
    (props.length ? props.firstPassword.length >= props.length : true) &&
    props.firstPassword.toLowerCase() !== props.firstPassword &&
    props.firstPassword.toUpperCase() !== props.firstPassword &&
    /\d/.test(props.firstPassword) &&
    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>?~]/.test(props.firstPassword) &&
    props.firstPassword.length > 0 && 
    (props.secondPassword ? (!!props.firstPassword && props.firstPassword === props.secondPassword) : true)
  )return true;
  else return false;
}

export const TextValidators = (props: Iprops) => {
  const [validLength, setValidLength] = useState(true);
  const [required, setRequired] = useState(false);

  useEffect(() => {
    if (props.text) {
      if (props.length) {
        setValidLength(props.text.length >= props.length ? true : false);
      }
      setRequired(props.text.length > 0 ? true : false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mb-8">
      {!required && (
        <div className="text-danger">{props.textType} is required.</div>
      )}
      {validLength}
      {!validLength && (
        <div className="text-danger">
          {props.textType} is at least {props.length} characters.
        </div>
      )}
    </div>
  );
};

export function validText(props: { text?: string; length?: number } = {}): boolean {
  if (!props || !props.text) return false;
  
  const text = props.text;
  const minLength = props.length || 1; // Default to 1 if length is not provided
  
  return text.length >= minLength;
}

export const PatternValidators = (props: Iprops) => {
  const [required, setRequired] = useState(false);
  const [valid, setValid] = useState(true);

  // const checkDomainExists = (email: string): Promise<boolean> => {
  //   const domain = email.split('@')[1];
  //   return new Promise((resolve, reject) => {
  //     dns.resolve(domain, 'MX', (err, addresses) => {
  //       if (err || !addresses) {
  //         reject(false);
  //       } else {
  //         resolve(true);
  //       }
  //     });
  //   });
  // };

  const checkEmail = async (paramPattern : any,regex : any) => {
    // let checkDNS = await checkDomainExists(paramPattern);
    setValid(regex.test(props.paramPattern));
  }

  useEffect(() => {

    if (props.patternType) {
          let temp: any =choosePatternType(props.patternType);
          if(props.patternType === 'decimal2Place'){
            let value : any = props.paramPattern;
            setRequired(value === 0 ? false : true);
            setValid(!String(props.paramPattern).split(".")[1]?.length || String(props.paramPattern).split(".")[1]?.length <= 2)
          } else if(props.patternType === 'dob'){
            if(props.paramPattern){
            setRequired(props.paramPattern?.length > 0 ? true : false);
            let response = validateBirthDate(props.paramPattern)
            setValid(props.paramPattern? response.valid : false);
            }else setRequired(false)
           
          }
          else if(props.patternType === 'numberOfInstallments'){
            let value : any = props.paramPattern;
            setRequired(value === 0 ? false : true);
            setValid(value > 0 && value <= 36)
          }else if(props.patternType === 'nric'){
            if (props.paramPattern){
              setRequired(props.paramPattern.length > 0 ? true : false);

              setValid(NRIC.validate(props.paramPattern));
            }
          } 
          else{
            if (props.paramPattern) {
              if(props.patternType === 'postalCode'){
                setRequired(props.paramPattern.length > 0 ? true : false);
                setValid(props.paramPattern.length === 6 && !isNaN(parseInt(props.paramPattern)))
              }else if(props.patternType === 'email'){
                var regex = new RegExp(temp);
                setRequired(props.paramPattern.length > 0 ? true : false);
                checkEmail(props.paramPattern,regex)
              }
              else{
              setRequired(props.paramPattern.length > 0 ? true : false);
              try {
                var regex1 = new RegExp(temp);
                setValid(regex1.test(props.paramPattern));

              } catch (e) {
              }
            }
            }
          }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mb-8">
      {!required && (
        <div className="text-danger">{props.textType} is required.</div>
      )}
      {!valid && (
        <div className="text-danger">
          {props.patternType === 'decimal2Place' &&
          <span>{props.textType} must not be more than two decimal places.</span> }
          {props.patternType === 'numberOfInstallments' &&
          <span>{props.textType} must not be more than 36.</span> }
 {props.patternType === 'unit' &&
          <span>{props.textType} must not be more than 6.</span> }
           {props.patternType === 'floor' &&
          <span>{props.textType} must not be more than 3.</span> }

          {props.patternType !== 'decimal2Place' && props.patternType !== 'numberOfInstallments' &&
          props.patternType !== 'floor' && props.patternType !== 'unit' &&
            <span>{props.textType} is invalid.</span>
          }
          </div>
      )}
    </div>
  );
};


export function validateBirthDate(dateString: any): { valid: boolean; error?: string } {

            // Convert ISO date string to DD/MM/YYYY format for validation
            const dd = new Date(dateString);
            const d = String(dd.getDate()).padStart(2, '0');
            const m = String(dd.getMonth() + 1).padStart(2, '0');
            const y = dd.getFullYear();
            const formattedDate = `${d}/${m}/${y}`;

    // Format check
    const formatRegex = /^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/;
    const match = formattedDate.match(formatRegex);
    
    if (!match) {
        return { valid: false, error: "Invalid date format. Use DD/MM/YYYY" };
    }
    
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    
    // Basic range checks
    if (month < 1 || month > 12) {
        return { valid: false, error: "Month must be between 1-12" };
    }
    
    if (day < 1 || day > 31) {
        return { valid: false, error: "Day must be between 1-31" };
    }
    
    // Reasonable birth date range (adjust as needed)
    const currentYear = new Date().getFullYear();
    if (year < 1900 || year > currentYear) {
        return { valid: false, error: `Year must be between 1900-${currentYear}` };
    }
    
    // Check if date actually exists
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day) {
        return { valid: false, error: "Date does not exist (e.g., Feb 31st)" };
    }
    
    // Check if birth date is not in the future
    if (date > new Date()) {
        return { valid: false, error: "Birth date cannot be in the future" };
    }
    
    return { valid: true };
}


const choosePatternType = (type : string) => {
  switch(type){
    case "email" : return emailPattern;
    case "mobile" : return mobilePattern;
    case "floor" : return floorPattern;
    case "unit" : return unitPattern;
    case "nric" : return nricPattern;
    case "uen" : return uenPattern;
  }
}

export function validPattern(props : any): any {
  let temp: any = choosePatternType(props.patternType);
  if(
    (props.patternType === 'postalCode' ? 
      (props.paramPattern.length === 6 && !isNaN(parseInt(props.paramPattern))) : 
    RegExp(temp).test(props.paramPattern)) 
  )return true;
  else return false;
}

export function validNRIC(props : any): any {
  if(props.paramPattern.length > 0 && NRIC.validate(props.paramPattern))return true;
  else return false;
}


export function validDecimal2Place(props : any): any {
  if(!String(props.paramPattern).split(".")[1]?.length || String(props.paramPattern).split(".")[1]?.length <= 2)return true;
  else return false;
}

export function validNoOfInstallments(props : any): any {
  if(props.paramPattern > 0 && props.paramPattern <= 36)return true;
  else return false;
}




// interface ValidatorHookState {
//   [key: string]: {
//     value: string;
//     accTxtBoxisValid: boolean;
//     isTouched: boolean;
//   };
// }

interface ValidatorHookState {
  [key: string]: {
    value: any;
    accTxtBoxisValid: boolean;
    isTouched: boolean;
  };
}
interface Errors {
  [key: string]: boolean;
}
interface ValidatorObject {
  [key: string]: (value: any) => boolean;
}

export function useValidator(initialValues: ValidatorHookState, validators: ValidatorObject) {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState<Errors>({});
  const [prevErrors, setPrevErrors] = useState({});
  useEffect(() => {
    const newErrors: any = {};
    for (const field in values) {
      const validator = validators[field];
      if (validator && values[field].isTouched) {
        const isValid = validator(values[field].value);
        if (!isValid) {
          newErrors[field] = true;
        }
      }
    }
    if (JSON.stringify(newErrors) !== JSON.stringify(prevErrors)) {
      setErrors(newErrors);
      setPrevErrors(newErrors);
    }
  }, [values, validators, prevErrors]);

  // function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    function handleChange(event: React.ChangeEvent<any>) {
    const { name, value } = event.target;

    setValues({
      ...values,
      [name]: {
        value,
        isTouched: true,
        accTxtBoxisValid: validators[name] ? validators[name](value) : true,
      },
    });
  }

  return { values, errors, handleChange, setValues };
}